import {
  Box,
  Button,
  Center,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  Portal,
  Select,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Textarea,
  Thead,
  Tr,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { MdDeleteOutline, MdOutlineAdd } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { ICenter } from "../../../models/centers.model";
import {
  ICourseType,
  IDuration,
  IProgramType,
} from "../../../models/course.model";
import Adminroutes from "../../../pages/admin/routes";
import AdminHelpers from "../../../services/admin/admin.service";
import Loading from "../../common/Loading";
import { CenterModal } from "../center-modal";

const AdminCreateProgram = () => {
  const courseFormatRef = useRef<HTMLSelectElement>(null);
  const navigate = useNavigate();
  const [programCategory, setprogramCategory] = useState<any[]>([]);
  const [course_types, setCourseTypes] = useState<ICourseType[]>([]);
  const [program_typess, setProgramTypess] = useState<IProgramType[]>([]);
  const [durationList, setDurationList] = useState<IDuration[]>([]);
  const [durationUnit, setDurationUnit] = useState<any[]>([]);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [isProgram, setIsProgram] = useState<number>(0);
  const [batchFile, setbatchFile] = useState<File | undefined>();
  const [filename, setFilename] = useState("");
  const [course_details, setCourseDetails] = useState<any>();
  const [filetype, setFiletype] = useState<string | undefined>("");
  const [loading, setLoading] = useState(true);
  const [cvalid, setCvalid] = useState(false);
  const toast = useToast();
  const [centersId, setCentersId] = useState<string[]>([]);
  const [centers, setCenters] = useState<ICenter[]>([]);
  const [isCenter, setIsCenter] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    const course_det = localStorage.getItem("naptin_course_info");
    if (course_det) {
      setCourseDetails(JSON.parse(course_det));
      setCvalid(true);
    }
    setForm();

    AdminHelpers.getCourseTypes().then((res) => {
      setCourseTypes(res.data);
      setLoading(false);
    });
    AdminHelpers.getProgramTypes().then((res) => {
      setProgramTypess(res.data);
      setLoading(false);
    });
    AdminHelpers.getCourseDuration().then((res) => {
      setDurationList(res.data);
      setLoading(false);
    });
    AdminHelpers.getProgramCategories().then((res) => {
      setprogramCategory(res);
      setLoading(false);
    });

    const durationUnit = [
      {
        id: "0",
        title: "Days",
      },
      {
        id: "1",
        title: "Weeks",
      },
      {
        id: "2",
        title: "Months",
      },
      {
        id: "3",
        title: "Years",
      },
    ];
    setDurationUnit(durationUnit);
  }, [cvalid]);

  const viewProgram = async (program_id: string) => {
    navigate(Adminroutes.programSettingsLink(program_id));
  };

  const updateCenters = (centres: ICenter[], centersId: any[]) => {
    setCenters(centres);
    setCentersId(centersId);
  };
  const openCenterModal = () => {
    setIsCenter(true);
    onOpen();
  };

  const removeCenter = (center: number) => {
    const ind = centersId.indexOf(center.toString());
    centersId.splice(ind, 1);
    centers.splice(ind, 1);
    setCentersId([...centersId]);
    setCenters([...centers]);
  };
  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};
      if (!values.courseTitle) {
        errors.courseTitle = "Course Title is required";
      }
      if (!values.courseDescription) {
        errors.courseDescription = "Course Description is required";
      }
      if (!values.generalObj) {
        errors.generalObj = "General Objective is required";
      }
      if (!values.programType) {
        errors.programType = "Program Type is required";
      }
      if (!values.programCategory) {
        errors.programCategory = "Program Category is required";
      }
      if (!values.cost) {
        errors.cost = "Cost is required";
      }
      if (!values.minDeposit) {
        errors.minDeposit = "Minimum Deposit is required";
      }else if(values.minDeposit && values.minDeposit > values.cost){
        errors.minDeposit = "Minimum Deposit cannot be more than program cost";
      }

      if (!values.duration) {
        errors.duration = "Duration is required";
      }
      if (!values.duration_unit) {
        errors.duration_unit = "Duration Unit is required";
      }
      if (!values.discount) {
        errors.discount = "Discount is required";
      }else if(values.discount && values.discount > values.cost){
        errors.discount = "Discount cannot be more than program cost";
      }
      if (!values.installment) {
        errors.installment = "Installment is required";
      }
      if (!values.duration_program) {
        errors.duration_program = "Duration Type is required";
      }

      return errors;
    },
    initialValues: {
      courseTitle: "",
      courseDescription: "",
      generalObj: "",
      specificObj: "",
      duration: "",
      programType: "",
      programCategory: "",
      cost: "",
      minDeposit: "",
      cover_image: "",
      installment: "",
      duration_unit: "",
      flyer: "",
      discount: "",
      status: "",
      duration_program: "",
      image: "",
    },
    onSubmit: async (values) => {
      if (batchFile) {
        const formData = new FormData();
        formData.append("cover_image", batchFile, filename);
        formData.append("name", values.courseTitle);
        formData.append("description", values.courseDescription);
        formData.append("general_objective", values.generalObj);
        formData.append("specific_objective", values.specificObj);
        formData.append("duration", values.duration);
        formData.append("program_duration_id", values.duration_program);
        formData.append("duration_unit", values.duration_unit);
        formData.append("discount", values.discount);
        formData.append("program_type_id", values.programType);
        formData.append("program_category_id", values.programCategory);
        formData.append("cost", values.cost);
        formData.append("min_deposit", values.minDeposit);
        formData.append("installment", values.installment);
        formData.append("is_program", "1");
        formData.append("status", "1");
        formData.append("available_centres", centersId.join(","));
        try {
          const basicResponse = await AdminHelpers.createCourse(formData);
          if (basicResponse) {
            viewProgram(basicResponse.data.uuid);
            const toastOptions = {
              description: "Program created successfully",
            };
            toast({
              title: "Program management",
              status: "success",
              isClosable: true,
              ...toastOptions,
            });
          }
        } catch (error: any) {
          toast({
            title: "Program management",
            description: `${error.response.data.message}`,
            status: "error",
          });
        }
      }
    },
  });
  const setForm = () => {
    if (course_details) {
      formik.setValues({
        courseTitle: course_details.name,
        courseDescription: course_details.description,
        generalObj: course_details.general_objective,
        specificObj: course_details.specific_objective,
        duration: course_details.duration,
        programType: course_details.course_type_id,
        programCategory: course_details.program_category_id,
        cost: course_details.cost,
        minDeposit: course_details.min_deposit,
        cover_image: "",
        installment: course_details.installment,
        duration_unit: course_details.duration_unit,
        flyer: "",
        discount: course_details.discount,
        status: "",
        duration_program: course_details.program_duration,
        image: "",
      });
    }
  };
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (value) {
      const fileName = e.target.files?.item(0)?.name as string;

      setFilename(fileName);
      const fileType = e.target.files?.item(0)?.type;
      if (!fileType?.startsWith("image/")) {
        toast({
          title: "Invalid Image Type",
          description: "Please select an image file",
          status: "error",
        });
      }

      setFiletype(fileType);
      const file = e.target.files?.item(0) as File;

      setbatchFile(file);
    }
  };
  const handleProgramChange = async (e: ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    if (value == "Program") {
      setIsProgram(1);
    } else {
      setIsProgram(0);
    }
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Flex
          bg="#F9F8F8"
          minHeight={"100vh"}
          py="25px"
          justifyContent={"center"}
          alignItems={"center"}
          flexDirection={"column"}
          gap={"1rem"}
        >
          <Box width={["90%", "90%", "80%", "60%"]}>
            <Box
              mb="60px"
              display="flex"
              alignItems="center"
              border="1px solid #616161"
              padding={"5px 12px"}
              width="fit-content"
              borderRadius="5px"
              cursor="pointer"
              justifyContent={"start"}
            >
              <HiArrowNarrowLeft color="#616161" fontSize="20px" />
              <Text
                fontSize="14px"
                color="#616161"
                pl="5px"
                onClick={() => navigate(-1)}
                fontWeight={700}
              >
                Go back
              </Text>
            </Box>

            <Box
              bg={"white"}
              width={"100%"}
              padding={"2rem"}
              boxShadow={"base"}
            >
              <Box px={6} mb="50px">
                <Flex justifyContent="center" mb="15px">
                  <Text mx="auto" fontSize="24px" fontWeight="800">
                    Program Creation
                  </Text>
                </Flex>
                <Flex justifyContent={"space-between"}>
                  <Text mt={"20px"} mb="20px" color="#9E9E9E" fontSize="14px">
                    All fields in (*) are required
                  </Text>
                </Flex>

                <form onSubmit={formik.handleSubmit}>
                  <Stack spacing={6} mt={6} mb="25px">
                    <FormControl
                      isInvalid={
                        (formik.errors.courseTitle &&
                          formik.touched.courseTitle) ||
                        false
                      }
                    >
                      <FormLabel
                        fontWeight="700"
                        color="#353535"
                        fontSize={{ base: "12px", md: "13px" }}
                      >
                        Title
                        <Text as="span" color="red">
                          *
                        </Text>
                      </FormLabel>
                      <Input
                        bg="inputText.500"
                        placeholder="Enter title"
                        value={formik.values.courseTitle}
                        name="courseTitle"
                        onChange={formik.handleChange}
                        fontSize={{ base: "11px", md: "12px" }}
                      />
                      <FormErrorMessage fontSize={{ base: "11px", md: "12px" }}>
                        {formik.errors.courseTitle}
                      </FormErrorMessage>
                    </FormControl>
                  </Stack>

                  <Stack
                    direction={{ base: "column", md: "row" }}
                    spacing={6}
                    mt={6}
                    mb="25px"
                  >
                    <FormControl
                      isInvalid={
                        (formik.errors.courseDescription &&
                          formik.touched.courseDescription) ||
                        false
                      }
                    >
                      <FormLabel
                        fontWeight="700"
                        color="#353535"
                        fontSize={{ base: "12px", md: "13px" }}
                      >
                        Description
                        <Text as="span" color="red">
                          *
                        </Text>
                      </FormLabel>
                      <Textarea
                        p={4}
                        bg="inputText.500"
                        fontSize={{ base: "11px", md: "12px" }}
                        size="md"
                        minH="100px"
                        name="courseDescription"
                        onChange={formik.handleChange}
                        value={formik.values.courseDescription}
                      />
                      <FormErrorMessage fontSize={{ base: "11px", md: "12px" }}>
                        {formik.errors.courseDescription}
                      </FormErrorMessage>
                    </FormControl>
                    <FormControl
                      isInvalid={
                        (formik.errors.generalObj &&
                          formik.touched.generalObj) ||
                        false
                      }
                    >
                      <FormLabel
                        fontWeight="700"
                        color="#353535"
                        fontSize={{ base: "12px", md: "13px" }}
                      >
                        General Objective
                        <Text as="span" color="red">
                          *
                        </Text>
                      </FormLabel>
                      <Textarea
                        p={4}
                        bg="inputText.500"
                        fontSize={{ base: "11px", md: "12px" }}
                        size="md"
                        minH="100px"
                        name="generalObj"
                        onChange={formik.handleChange}
                        value={formik.values.generalObj}
                      />
                      <FormErrorMessage fontSize={{ base: "11px", md: "12px" }}>
                        {formik.errors.generalObj}
                      </FormErrorMessage>
                    </FormControl>
                  </Stack>

                  <Stack
                    direction={{ base: "column", md: "row" }}
                    spacing={6}
                    mt={6}
                    mb="25px"
                  >
                    <FormControl
                      isInvalid={
                        (formik.errors.programType &&
                          formik.touched.programType) ||
                        false
                      }
                    >
                      <FormLabel
                        fontWeight="700"
                        color="#353535"
                        fontSize={{ base: "12px", md: "13px" }}
                      >
                        {/* Technicality */}
                        Program Type
                        <Text as="span" color="red">
                          *
                        </Text>
                      </FormLabel>
                      <Select
                        variant="outline"
                        bg="inputText.500"
                        size="md"
                        placeholder="Select"
                        value={formik.values.programType}
                        name="programType"
                        onChange={formik.handleChange}
                        fontSize={{ base: "11px", md: "12px" }}
                        color="brand.subtitle"
                      >
                        {program_typess.map((each) => (
                          <option key={each.id} value={each.id}>
                            {each.name}
                          </option>
                        ))}
                      </Select>
                      <FormErrorMessage fontSize={{ base: "11px", md: "12px" }}>
                        {formik.errors.programType}
                      </FormErrorMessage>
                    </FormControl>
                    <FormControl
                      isInvalid={
                        (formik.errors.programCategory &&
                          formik.touched.programCategory) ||
                        false
                      }
                    >
                      <FormLabel
                        fontWeight="700"
                        color="#353535"
                        fontSize={{ base: "12px", md: "13px" }}
                      >
                        Category
                        <Text as="span" color="red">
                          *
                        </Text>
                      </FormLabel>
                      <Select
                        ref={courseFormatRef}
                        variant="outline"
                        bg="inputText.500"
                        size="md"
                        fontSize={{ base: "11px", md: "12px" }}
                        placeholder="Select category"
                        value={formik.values.programCategory}
                        name="programCategory"
                        onChange={formik.handleChange}
                        color="brand.subtitle"
                      >
                        {programCategory.map((each) => (
                          <option key={each.id} value={each.id}>
                            {each.name}
                          </option>
                        ))}
                      </Select>
                      <FormErrorMessage fontSize={{ base: "11px", md: "12px" }}>
                        {formik.errors.programCategory}
                      </FormErrorMessage>
                    </FormControl>
                    <FormControl
                      isInvalid={
                        (formik.errors.duration_program &&
                          formik.touched.duration_program) ||
                        false
                      }
                    >
                      <FormLabel
                        fontWeight="700"
                        color="#353535"
                        fontSize={{ base: "12px", md: "13px" }}
                      >
                        Duration Type
                        <Text as="span" color="red">
                          *
                        </Text>
                      </FormLabel>
                      <Select
                        variant="outline"
                        bg="inputText.500"
                        size="md"
                        fontSize={{ base: "11px", md: "12px" }}
                        placeholder="Select duration type"
                        value={formik.values.duration_program}
                        name="duration_program"
                        onChange={formik.handleChange}
                        color="brand.subtitle"
                      >
                        {durationList.map((each) => (
                          <option key={each.id} value={each.id}>
                            {each.name}
                          </option>
                        ))}
                      </Select>
                      <FormErrorMessage fontSize={{ base: "11px", md: "12px" }}>
                        {formik.errors.duration_program}
                      </FormErrorMessage>
                    </FormControl>
                  </Stack>

                  <Stack
                    direction={{ base: "column", md: "row" }}
                    spacing={6}
                    mb="25px"
                    mt={6}
                  >
                    <FormControl
                      isInvalid={
                        (formik.errors.cost && formik.touched.cost) || false
                      }
                    >
                      <FormLabel
                        fontWeight="700"
                        color="#353535"
                        fontSize={{ base: "12px", md: "13px" }}
                      >
                        Cost
                        <Text as="span" color="red">
                          *
                        </Text>
                      </FormLabel>
                      <InputGroup size="md">
                        <InputLeftElement width="1.5rem">
                          <Text>₦</Text>
                        </InputLeftElement>
                        <Input
                          bg="inputText.500"
                          type="number"
                          placeholder="Enter amount"
                          value={formik.values.cost}
                          name="cost"
                          onChange={formik.handleChange}
                          fontSize={{ base: "11px", md: "12px" }}
                        />
                      </InputGroup>
                      <FormErrorMessage fontSize={{ base: "11px", md: "12px" }}>
                        {formik.errors.cost}
                      </FormErrorMessage>
                    </FormControl>

                    <FormControl
                      isInvalid={
                        (formik.errors.minDeposit &&
                          formik.touched.minDeposit) ||
                        false
                      }
                    >
                      <FormLabel
                        fontWeight="700"
                        color="#353535"
                        fontSize={{ base: "12px", md: "13px" }}
                      >
                        Min. Deposit
                        <Text as="span" color="red">
                          *
                        </Text>
                      </FormLabel>
                      <InputGroup size="md">
                        <InputLeftElement width="1.5rem">
                          <Text>₦</Text>
                        </InputLeftElement>
                        <Input
                          bg="inputText.500"
                          type="number"
                          placeholder="Enter amount"
                          value={formik.values.minDeposit}
                          name="minDeposit"
                          onChange={formik.handleChange}
                          fontSize={{ base: "11px", md: "12px" }}
                        />
                      </InputGroup>
                      <FormErrorMessage fontSize={{ base: "11px", md: "12px" }}>
                        {formik.errors.minDeposit}
                      </FormErrorMessage>
                    </FormControl>
                    <FormControl
                      isInvalid={
                        (formik.errors.installment &&
                          formik.touched.installment) ||
                        false
                      }
                    >
                      <FormLabel
                        fontWeight="700"
                        color="#353535"
                        fontSize={{ base: "12px", md: "13px" }}
                      >
                        Installment
                        <Text as="span" color="red">
                          *
                        </Text>
                      </FormLabel>
                      <Input
                        bg="inputText.500"
                        type="number"
                        placeholder="Enter allowed installment"
                        value={formik.values.installment}
                        name="installment"
                        onChange={formik.handleChange}
                        fontSize={{ base: "11px", md: "12px" }}
                      />
                      <FormErrorMessage fontSize={{ base: "11px", md: "12px" }}>
                        {formik.errors.installment}
                      </FormErrorMessage>
                    </FormControl>
                  </Stack>

                  <Stack
                    direction={{ base: "column", md: "row" }}
                    mb="25px"
                    mt={6}
                    spacing={6}
                  >
                    <FormControl
                      isInvalid={
                        (formik.errors.discount && formik.touched.discount) ||
                        false
                      }
                    >
                      <FormLabel
                        fontWeight="700"
                        color="#353535"
                        fontSize={{ base: "12px", md: "13px" }}
                      >
                        Discount
                        <Text as="span" color="red">
                          *
                        </Text>
                      </FormLabel>
                      <InputGroup size="md">
                        <InputLeftElement width="1.5rem">
                          <Text>₦</Text>
                        </InputLeftElement>
                        <Input
                          bg="inputText.500"
                          type="number"
                          placeholder="Enter amount"
                          value={formik.values.discount}
                          name="discount"
                          onChange={formik.handleChange}
                          fontSize={{ base: "11px", md: "12px" }}
                        />
                      </InputGroup>
                      <FormErrorMessage fontSize={{ base: "11px", md: "12px" }}>
                        {formik.errors.discount}
                      </FormErrorMessage>
                    </FormControl>

                    <FormControl
                      isInvalid={
                        (formik.errors.duration_unit &&
                          formik.touched.duration_unit) ||
                        false
                      }
                    >
                      <FormLabel
                        fontWeight="700"
                        color="#353535"
                        fontSize={{ base: "12px", md: "13px" }}
                      >
                        Program Duration
                        <Text as="span" color="red">
                          *
                        </Text>
                      </FormLabel>
                      <Select
                        variant="outline"
                        bg="inputText.500"
                        size="md"
                        placeholder="Duration Unit"
                        value={formik.values.duration_unit}
                        name="duration_unit"
                        onChange={formik.handleChange}
                        fontSize={12}
                        color="brand.subtitle"
                      >
                        {durationUnit.map((each) => (
                          <option key={each.id} value={each.title}>
                            {" "}
                            {each.title}{" "}
                          </option>
                        ))}
                      </Select>
                      <FormErrorMessage fontSize={{ base: "11px", md: "12px" }}>
                        {formik.errors.duration_unit}
                      </FormErrorMessage>
                    </FormControl>

                    <FormControl
                      isInvalid={
                        (formik.errors.duration && formik.touched.duration) ||
                        false
                      }
                    >
                      <FormLabel
                        fontWeight="700"
                        color="#353535"
                        fontSize={{ base: "12px", md: "13px" }}
                      >
                        Duration
                        <Text as="span" color="red">
                          *
                        </Text>
                      </FormLabel>
                      <InputGroup size="md">
                        <Input
                          bg="inputText.500"
                          type="number"
                          placeholder="Enter duration"
                          value={formik.values.duration}
                          name="duration"
                          onChange={formik.handleChange}
                          fontSize={{ base: "11px", md: "12px" }}
                        />
                      </InputGroup>
                      <FormErrorMessage fontSize={{ base: "11px", md: "12px" }}>
                        {formik.errors.duration}
                      </FormErrorMessage>
                    </FormControl>
                  </Stack>

                  {filename && (
                    <Box>
                      <Table variant="unstyled">
                        <Thead fontWeight="semibold">
                          <Tr color="brand.subtitle" fontSize={14}>
                            <Td>Filename</Td>
                            <Td>Type</Td>
                          </Tr>
                        </Thead>

                        <Tbody>
                          <Tr fontSize={13} color="brand.subtitle">
                            <Td maxW="20em">{filename}</Td>
                            <Td>Image</Td>
                          </Tr>
                        </Tbody>
                      </Table>
                    </Box>
                  )}
                  <FormControl mr={10}>
                    <FormLabel fontWeight="600" color="#616161" fontSize={13}>
                      Upload Cover Image
                    </FormLabel>
                    <Text fontWeight="400" color="#959595" fontSize="14px">
                      Upload an image of the course. (Not larger than 2MB)
                    </Text>

                    <input
                      accept="image/*"
                      type="file"
                      name="cover_image"
                      ref={inputRef}
                      onChange={(e) => handleFileChange(e)}
                      style={{ display: "none" }}
                    ></input>
                    <Input
                      cursor="pointer"
                      placeholder="No file selected"
                      defaultValue={filename}
                      mt="10px"
                      borderColor="#eeeeee"
                      fontSize={14}
                      bg="#fafafa"
                      onClick={() => inputRef?.current?.click()}
                      border="2px dashed"
                      borderRadius={2}
                      height={"100px"}
                    />

                    <FormErrorMessage fontSize={12}>
                      {" "}
                      {formik.errors.cover_image}{" "}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl mt={"20px"} pb="25px">
                    <FormLabel fontWeight="700" color="#616161" fontSize="13px">
                      <Flex>
                        <Text mr="10px">Add Centers</Text>
                        <Center
                          fontSize="20px"
                          onClick={() => {
                            openCenterModal();
                          }}
                          border="lightgray 2px dashed"
                        >
                          <MdOutlineAdd />
                        </Center>
                      </Flex>
                    </FormLabel>
                    {centers.length > 0 &&
                      centers.map((each, index) => (
                        <Flex
                          pb="8px"
                          key={index}
                          width={["100%", "100%", "240px", "240px"]}
                          justifyContent="space-between"
                        >
                          <Text>{each.name}</Text>
                          <Center
                            cursor={"pointer"}
                            fontSize="20px"
                            onClick={() => {
                              removeCenter(each.id);
                            }}
                          >
                            <MdDeleteOutline />
                          </Center>
                        </Flex>
                      ))}
                  </FormControl>

                  <Flex
                    mb="50px"
                    justifyContent="flex-end"
                    alignItems="baseline"
                    mt={6}
                    gap={"1rem"}
                  >
                    <Button
                      colorScheme="white"
                      color="red"
                      size="sm"
                      variant={"outline"}
                      fontSize={11}
                      py="13px"
                      px="30px"
                      mt="30px"
                    >
                      CANCEL
                    </Button>
                    <Button
                      py="13px"
                      px="30px"
                      mt="30px"
                      type="submit"
                      fontSize={11}
                      colorScheme="red"
                      size="sm"
                    >
                      NEXT
                    </Button>
                  </Flex>
                </form>
              </Box>
              {isCenter && (
                <Portal>
                  {" "}
                  <CenterModal
                    isOpenCenter={isOpen}
                    onCloseCenter={onClose}
                    isCenter={isCenter}
                    updateCenters={updateCenters}
                    centers={centers}
                    centersId={centersId}
                  />{" "}
                </Portal>
              )}
            </Box>
          </Box>
        </Flex>
      )}
    </>
  );
};

export default AdminCreateProgram;
